import { Input } from "antd";

const TextArea = ({placeholder="Enter your text...", handleTextChange, text, rows=4, className=""}) => {

  return (
    <div >
      <Input.TextArea
        rows={rows}
        value={text}
        onChange={(e) => handleTextChange(e.target.value)}
        placeholder={placeholder}
        className={className}
      />
    </div>
  );
};
export default TextArea;
